const map = {
	"./abh.png": 9853,
	"./docx.png": 10,
	"./dxb.png": 7908,
	"./emirates-sc.png": 9286,
	"./esc-logo.png": 8613,
	"./fb.png": 5452,
	"./insta.png": 5383,
	"./jacket.png": 430,
	"./logo.png": 3153,
	"./logo_180.png": 7145,
	"./logo_round.png": 2152,
	"./pdf.png": 2752,
	"./tiktok.png": 4934,
	"./yt.png": 4431
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;